module.exports = __webpack_public_path__ + "img/VIP-12.52284ffb.png";